<template>
  <div class="mt-4 bg-white shadow sm:rounded-lg">
    <div class="px-4 py-5 sm:p-6">
      <div class="grid grid-cols-1 gap-4 sm:grid-cols-5">
        <div>
          <label class="block text-sm font-medium text-gray-700">Search in title and content</label>
          <input
            v-model="filters.search"
            type="text"
            placeholder="Search by title or content"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            @keyup.enter="$emit('apply-filters', filters)"
          />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700">Source</label>
          <select
            v-model="filters.source"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            @change="$emit('apply-filters', filters)"
          >
            <option :value="undefined">All Sources</option>
            <option v-for="source in allSources" :key="source" :value="source">
              {{ source }}
            </option>
          </select>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700">Language</label>
          <select
            v-model="filters.language"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            @change="$emit('apply-filters', filters)"
          >
            <option :value="undefined">All Languages</option>
            <option v-for="lang in availableLanguages" :key="lang.code" :value="lang.code">
              {{ lang.name }}
            </option>
          </select>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700">Importance</label>
          <select
            v-model="filters.is_important"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            @change="$emit('apply-filters', filters)"
          >
            <option :value="undefined">All</option>
            <option :value="true">Important</option>
            <option :value="false">Not Important</option>
          </select>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700">Relevance</label>
          <select
            v-model="filters.relevance"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            @change="$emit('apply-filters', filters)"
          >
            <option :value="undefined">All</option>
            <option value="visoka">High (Visoka)</option>
            <option value="srednja">Medium (Srednja)</option>
            <option value="niska">Low (Niska)</option>
          </select>
        </div>
      </div>
      <div class="mt-4 flex justify-end space-x-3">
        <button
          @click="resetFilters"
          class="inline-flex justify-center rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
        >
          Reset Filters
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'

interface ContentFilters {
  page: number
  page_size: number
  search?: string
  source?: string
  language?: string
  is_important?: boolean
  relevance?: string
}

interface Language {
  code: string
  name: string
}

const props = defineProps<{
  sources: Record<string, number>
}>()

const filters = ref<ContentFilters>({
  page: 1,
  page_size: 100,
  search: '',
  source: undefined,
  language: undefined,
  is_important: undefined,
  relevance: undefined
})

// Available languages - hardcoded for now, could be fetched from API
const availableLanguages: Language[] = [
  { code: 'sr', name: 'Serbian (Srpski)' },
  { code: 'en', name: 'English' },
  { code: 'hr', name: 'Croatian (Hrvatski)' },
  { code: 'de', name: 'German (Deutsch)' }
]

// Get unique sources from props, limited to first 50
const allSources = computed(() => {
  const sources = Object.keys(props.sources || {})
  // Add "Manual Entry" if it's not already included
  if (!sources.includes('Manual Entry')) {
    sources.push('Manual Entry')
  }
  return sources.slice(0, 50).sort()
})

const emit = defineEmits<{
  (e: 'apply-filters', filters: ContentFilters): void
}>()

function resetFilters() {
  filters.value = {
    page: 1,
    page_size: 100,
    search: '',
    source: undefined,
    language: undefined,
    is_important: undefined,
    relevance: undefined
  }
  emit('apply-filters', filters.value)
}
</script> 